import { render, staticRenderFns } from "./sales_receipt.vue?vue&type=template&id=2c9dc8bf"
import script from "./sales_receipt.vue?vue&type=script&lang=js"
export * from "./sales_receipt.vue?vue&type=script&lang=js"
import style0 from "./sales_receipt.vue?vue&type=style&index=0&id=2c9dc8bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports